module.exports = __webpack_public_path__ + "blueom.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blueom.png
// module id = 877
// module chunks = 0